import { StyleSheet } from 'aphrodite'
export default StyleSheet.create({
  formGroup: {
    marginBottom: '1em',
    width: '16em',
  },
  formFeedback: {
    color: 'red',
  },
  inputNumber: {
    width: '100%',
  },
})
